<template>
<div class="component">
<div class="columns is-mobile">
<div class="column is-2 has-text-left">
    <div class="button is-size-4" @click="openProjectOverview()">Zurück</div></div><div class="column is-8">
    <div class="wwTitle">Benutzerverwaltung</div></div>
    </div>
    <div class="subtitle">Verwendete Benutzerlizenzen: {{companyuser.length}} von 10</div>
    <div class="button" @click="openCreateNewUser()" v-if="companyuser.length <10">Benutzer hinzufügen</div>
    <table class="table is-fullwidth">

        <tr>
            <th width="50%">Name</th>
            <th width="25%">Bearbeiten</th>
            <th width="25%">Löschen</th>
        </tr>
        <tr v-for="user in companyuser">
            <td>
                <div class="userName">{{user.name}} {{user.lastName}}</div>
            </td>
            <td @click="openEditUserModal(user)">
                <div class="button">Bearbeiten</div>
            </td>
            <td><span v-if="!user.is_admin">
                    <div class="button is-danger" @click="deleteUser(user)">Löschen</div>
                </span></td>
        </tr>
    </table>
    <createEditUserModal :user="userToEdit" @close="closeUserModal()" @refresh="getUser()" :isActive="newUserModal" />

</div>
</template>

<script>
import createEditUserModal from '@/components/createEditUser.vue'

export default {
    name: 'UserAdministration',
    props: [],
    mounted: function () {
        this.getUser();
    },
    components: {
        createEditUserModal
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            companyuser: [],
            newUserModal: false,
            userToEdit: null,
        }
    },
    methods: {
        getUser() {

            this.callApi("/user/all").then(function (response) {
                this.companyuser = response.data.user
            }.bind(this))
        },
        openCreateNewUser() {
            this.userToEdit = null;
            this.newUserModal = true;
        },
        openEditUserModal(user) {
            this.userToEdit = user;
            this.newUserModal = true;
        },
        closeUserModal() {
            this.userToEdit = null;
            this.newUserModal = false;
        },
        deleteUser(user) {
            let postData = {
                "userId": user.id
            }
            this.callApi("/user/delete", "post", postData).then(function (response) {
                this.getUser();
            }.bind(this))

        },
        openProjectOverview(){
             this.$router.push({
                    name: 'Projects'
                })
        },

    },
    computed: {},
}
</script>

<style scoped>
.userName {
    padding-top: calc(0.5em - 1px);
    padding-bottom: calc(0.5em - 1px);
}
</style>
